module.exports = parcelRequire.resolve("69lc5");